import { createApp, h } from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagVue from '@bugsnag/plugin-vue';
import ElementPlus from 'element-plus';
import { mapStores } from 'pinia';
import nxtVue from '@nextories/vue-core-components';
import axios from '@nextories/vue-core-components/src/utils/modules/axios';
import '@nextories/vue-core-components/src/assets/scss/external/element-variables.scss';
import AppApi from './utils/AppApi';
import './assets/scss/app.scss';
import App from './App.vue';
import components from './components';
import { usePartnerStore } from './store/partnerStore';
import { useAnalyticsStore } from '@nextories/vue-core-components/src/store/analyticsStore';
import { i18nPlugin } from './plugins/i18n';
import piniaPlugin from './plugins/pinia';

function loadEmbedStylesheet() {
  if (import.meta.env.DEV) {
    return;
  }
  const buildBaseUrl = import.meta.env.VITE_APP_BUILD_BASE_URL;
  if (!buildBaseUrl) {
    return;
  }
  const id = 'nxt-lead-form-styles';
  if (document.getElementById(id)) {
    return;
  }
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `${buildBaseUrl}assets/style.css`;
  document.head.appendChild(link);
}

loadEmbedStylesheet();

const el = document.getElementById('nxt-lead-form');

const app = createApp({
  data() {
    return {
      prefixCSS: import.meta.env.nxt.prefixCSS ? `${import.meta.env.nxt.prefixCSS}-` : '',
    };
  },
  computed: {
    // note we are not passing an array, just one store after the other
    // each store will be accessible as its id + 'Store'
    ...mapStores(usePartnerStore, useAnalyticsStore),
  },
  beforeMount() {
    if (window.nxtConfigLocal
      || (el && this.$helpers.configStore.setValueStore(el, 'config-id', 'config_id', this.partnerStore, `setConfigId`))) {
      this.$helpers.configStore.setValueStore(el, 'partner-id', 'partner', this.partnerStore,`setPartnerId`);
      for (const item of [
        { value: 'utm_source', action: 'setUtmSource', dataIsPriority: true },
        { value: 'utm_medium', action: 'setUtmMedium', dataIsPriority: true },
        { value: 'utm_campaign', action: 'setUtmCampaign', dataIsPriority: true },
        { value:'gclid', action: 'setGclid'},
        { value:'msclkid', action: 'setMsclkid'},
        { value: 'partner_lead_id', action: 'setPartnerLeadId', notCookie: true },
      ]) {
        // Save value in store
        // Default get value to 'get' or 'data'
        // if 'dataIsPriority' get value to 'data' or 'get'
        this.$helpers.configStore.setValueStore(
          el,
          item.value.replace(/(_)/g, '-'),
          item.value,
          this.partnerStore,
          item.action,
          !item.notCookie ? item.value : '',
          !!item.dataIsPriority,
        );
      }
      for (const item of [{
        value: 'ga-id',
        action: 'setGaId',
      }, {
        value: 'ga-deactivate',
        action: 'setGaDeactivate',
      }, {
        value: 'initial-data',
        action: 'setInitialData',
        store: this.partnerStore,
      }, {
        value: 'custom-id',
        action: 'setCustomId',
        store: this.partnerStore,
      }]) {
        const value = item.value ? item.value : item;
        // Save data value in store
        // Exemple: data-ga-id="nextories"
        this.$helpers.configStore.setDataValueStore(el, value,
          item.action, item.store ? item.store : this.analyticsStore);
      }
    }
    if (window.nxtConfigLocal) {
      this.partnerStore.setPartnerConfig({ config: window.nxtConfigLocal });
    }
  },
  render() {
    return h(App);
  },
});
app.use(i18nPlugin);
app.use(piniaPlugin);
Object.entries(components)
  .forEach((entry) => {
    const name = `${entry[0]}`;
    entry[1].name = name;
    app.component(name, entry[1]);
  });
app.config.globalProperties.$API = axios();
if (nxtVue?.install) {
  app.use(nxtVue.install);
}
app.config.globalProperties.$APP_API = axios();
window.connector = new AppApi(app.config.globalProperties.$APP_API);
app.mount('#nxt-lead-form');
